export default "__VITE_ASSET__Db$eaccR__"